import Axios from '../config/Axios';

export function getFolder(nFolderId) {
  return Axios.get('/folder', { params: { nFolderId } }).then((oResponse) => oResponse.data.oFolder);
}

export function moveFolder(nId, nDestinyFolderId) {
  return Axios.post('/folder/move', { nId, "nFolderId": nDestinyFolderId });
}
